/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FailedTransactionDetailsViewModel } from '../models/FailedTransactionDetailsViewModel';
import type { FailedTransactionListViewModel } from '../models/FailedTransactionListViewModel';
import type { GetFailedTransactionForAdminQuery } from '../models/GetFailedTransactionForAdminQuery';
import type { ListFailedTransactionsForAdminQuery } from '../models/ListFailedTransactionsForAdminQuery';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FailedTransactionsAdminService {
    /**
     * @param requestBody
     * @returns FailedTransactionListViewModel Success
     * @throws ApiError
     */
    public static postApiFailedTransactionsAdminList(
        requestBody?: ListFailedTransactionsForAdminQuery,
    ): CancelablePromise<FailedTransactionListViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/failed-transactions-admin/list',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns FailedTransactionDetailsViewModel Success
     * @throws ApiError
     */
    public static postApiFailedTransactionsAdminGet(
        requestBody?: GetFailedTransactionForAdminQuery,
    ): CancelablePromise<FailedTransactionDetailsViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/failed-transactions-admin/get',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
}
